import Box from '@mui/material/Box';
import { JobTypes } from 'BMapsSrc/jobman';
import JobForm from 'BMapsSrc/jobman/forms/JobForm';
import { UserActions } from 'BMapsSrc/cmds';
import DialogContentSection from 'BMapsUI/common/DialogContentSection';
import LinkLikeButton from 'BMapsUI/common/LinkLikeButton';
import { Loader } from 'BMapsSrc/Loader';
import { conditionalArrayItem } from 'BMapsSrc/util/js_utils';

// Job types offered from this tab. Each must implement `jobForm` and
// `buildRequestPayload` on its `JobDefinition` — see ReinventJob/DrugFlowJob
// for examples.
const moleculeGenerationJobTypeIds = [
    JobTypes.REINVENT,
    ...conditionalArrayItem(Loader.AllowLabFeatures, JobTypes.DRUGFLOW),
    JobTypes.RXN_ENUM,
    JobTypes.MOLEXAR,
];

export default function CompoundGenerationTab({ initData }) {
    return (
        <div>
            <DialogContentSection title="AI Compound Generation" disablePaddingBottom>
                Derive new compounds using an AI program.
            </DialogContentSection>
            <JobForm
                jobTypeIds={moleculeGenerationJobTypeIds}
                initData={initData}
                header={{
                    title: 'Select Compound Generation Program',
                    fields: {
                        // `row` sits them side by side — see FieldList.jsx's
                        // `groupByRow`. A tab that wants them stacked instead
                        // (e.g. a folding-shaped tab) just wouldn't set this.
                        chosenJobType: {
                            widget: 'jobTypeSelect',
                            label: 'Program',
                            omitFromPayload: true,
                            row: true,
                        },
                        jobName: {
                            widget: 'jobName',
                            label: 'Job Name (optional)',
                            default: '',
                            initialValueFrom: (data) => data?.jobName,
                            omitFromPayload: true,
                            row: true,
                        },
                    },
                }}
                footer={{
                    title: 'Submit Compound Generation Job',
                    fields: {
                        submitButton: {
                            widget: 'submit',
                            label: 'Submit for Compound Generation',
                            tooltip: 'Click to submit compound generation job',
                        },
                        completedJobsNote: {
                            widget: 'content',
                            content: (
                                <Box sx={{ marginTop: '1rem' }}>
                                    <span style={{ fontStyle: 'italic' }}>
                                        Completed jobs will be available in the
                                        {' '}
                                        <LinkLikeButton
                                            onClick={() => UserActions.OpenImport('jobs_compounds_tab')}
                                            style={{ padding: 0, verticalAlign: 'unset' }}
                                        >
                                            Compound Jobs
                                        </LinkLikeButton>
                                        {' '}
                                        tab.
                                        <br />
                                        Load a completed job to view the generated compounds
                                        and import them into your workspace.
                                    </span>
                                </Box>
                            ),
                        },
                    },
                }}
                onSubmitSuccess={(results) => (
                    UserActions.OpenImport('jobs_compounds_tab', { jobid: results?.jobid })
                )}
            />
        </div>
    );
}
